import type { Components, Theme } from "@mui/material";

export const badgeTheme: Components<Theme>["MuiBadge"] = {
  defaultProps: {
    color: "primary",
  },
};
